import { RadioGroupField } from '@shared/ui/radio-group/types';
import { INPUT_TYPE, InputFileSearchValue } from './types';
import { DefaultSortOptionValues } from '@shared/ui/dropdown-sort/types';
import { FilesListDataRequest } from '@shared/api/file/file-types';

export const DEFAULT_INPUT_FILE_VALUE: InputFileSearchValue = {
    localFiles: [],
    initialUploadedFiles: [],
    addedUploadedFiles: [],
    deletedUploadedFiles: [],
    filesQueue: [],
};

export const INPUT_TYPE_RADIOS: RadioGroupField[] = [
    {
        label: 'Загрузить',
        value: INPUT_TYPE.Upload,
        checked: true,
    },
    {
        label: 'Выбрать',
        value: INPUT_TYPE.Search,
    },
];

export const SEARCH_OPTIONS_VALUE = [];

export const DEFAULT_PARAMETERS: FilesListDataRequest = {
    search: '',
    take: 10,
    skip: null,
    order: 'createdAt',
    sort: DefaultSortOptionValues.New,
};
